import React from 'react';

export default function LogsStats({ stats }) {
  const {
    total = 0,
    errors = 0,
    critical = 0,
    users = 0,
    sessions = 0,
    today = 0,
    this_week = 0,
    this_month = 0
  } = stats;

  const errorRate = total > 0 ? ((errors / total) * 100).toFixed(1) : 0;
  const criticalRate = total > 0 ? ((critical / total) * 100).toFixed(1) : 0;

  const statsCards = [
    {
      title: 'Total de Logs',
      value: total.toLocaleString(),
      icon: 'bi-archive',
      color: 'primary',
      subtitle: 'Registros totais'
    },
    {
      title: 'Hoje',
      value: today.toLocaleString(),
      icon: 'bi-calendar-day',
      color: 'info',
      subtitle: 'Logs de hoje'
    },
    {
      title: 'Últimos 7 dias',
      value: this_week.toLocaleString(),
      icon: 'bi-calendar-week',
      color: 'info',
      subtitle: 'Janela móvel'
    },
    {
      title: 'Últimos 30 dias',
      value: this_month.toLocaleString(),
      icon: 'bi-calendar-month',
      color: 'info',
      subtitle: 'Janela móvel'
    },
    {
      title: 'Usuários Ativos',
      value: users.toLocaleString(),
      icon: 'bi-people',
      color: 'success',
      subtitle: 'Usuários únicos'
    },
    {
      title: 'Sessões',
      value: sessions.toLocaleString(),
      icon: 'bi-device-ssd',
      color: 'success',
      subtitle: 'Sessões ativas'
    },
    {
      title: 'Erros',
      value: errors.toLocaleString(),
      icon: 'bi-exclamation-triangle',
      color: 'danger',
      subtitle: `${errorRate}% do total`
    },
    {
      title: 'Críticos',
      value: critical.toLocaleString(),
      icon: 'bi-shield-exclamation',
      color: 'warning',
      subtitle: `${criticalRate}% do total`
    }
  ];

  return (
    <div className="row mb-4">
      {statsCards.map((stat, index) => (
        <div key={index} className="col-xl-3 col-lg-4 col-md-6 mb-3">
          <div className={`card stats-card stats-card-${stat.color}`}>
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="stats-icon">
                  <i className={`bi ${stat.icon}`}></i>
                </div>
                <div className="flex-grow-1 ms-3">
                  <div className="stats-label">{stat.title}</div>
                  <div className="stats-value">{stat.value}</div>
                  <div className="stats-subtitle">{stat.subtitle}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
      
      <style>{`
        .stats-card {
          background: rgba(18, 26, 23, 0.8);
          border: 1px solid rgba(132, 169, 140, 0.15);
          border-radius: 12px;
          transition: all 0.3s ease;
        }
        
        .stats-card:hover {
          border-color: rgba(132, 169, 140, 0.3);
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }
        
        .stats-icon {
          width: 48px;
          height: 48px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
        }
        
        .stats-card-primary .stats-icon {
          background: rgba(13, 110, 253, 0.1);
          color: #0d6efd;
        }
        
        .stats-card-info .stats-icon {
          background: rgba(13, 202, 240, 0.1);
          color: #0dcaf0;
        }
        
        .stats-card-success .stats-icon {
          background: rgba(132, 169, 140, 0.1);
          color: #84a98c;
        }
        
        .stats-card-danger .stats-icon {
          background: rgba(220, 53, 69, 0.1);
          color: #dc3545;
        }
        
        .stats-card-warning .stats-icon {
          background: rgba(255, 193, 7, 0.1);
          color: #ffc107;
        }
        
        .stats-label {
          font-size: 0.875rem;
          font-weight: 600;
          color: rgba(255, 255, 255, 0.7);
          margin-bottom: 0.25rem;
        }
        
        .stats-value {
          font-size: 1.75rem;
          font-weight: 700;
          color: #ffffff;
          line-height: 1;
          margin-bottom: 0.25rem;
        }
        
        .stats-subtitle {
          font-size: 0.75rem;
          color: rgba(255, 255, 255, 0.5);
        }
        
        .card-body {
          padding: 1.25rem;
        }
      `}</style>
    </div>
  );
}